import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { axiosInstance } from '../../axios/interceptor'
import { clearLocalStorage } from '../../helper/storage'

export const createChatRoom = createAsyncThunk('chat/room', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post(`/chat/chat-rooms/create-chat-room`, {
      property_schedule_id: id
    })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})
export const getChatRoom = createAsyncThunk('chat/getroom', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/chat/chat-rooms/get-chat-room/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

const initialState = {
  isLoading: false,
  roomInfo: [],
  chatDetails:[],
  error: null
}

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    resetAuthState: (state) => {
      state.chat = null
      clearLocalStorage()
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createChatRoom.pending, (state) => {
        state.isLoading = true
      })
      .addCase(createChatRoom.fulfilled, (state, action) => {
        state.isLoading = false
        state.roomInfo = action.payload?.data?.data
      })
      .addCase(createChatRoom.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getChatRoom.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getChatRoom.fulfilled, (state, action) => {
        state.isLoading = false
        state.chatDetails = action.payload?.data?.data
      })
      .addCase(getChatRoom.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
  }
})

export const { resetAuthState } = chatSlice.actions
export default chatSlice.reducer
